import { Component, OnInit } from '@angular/core';
import {AchooInputComponent} from '../achoo-input/achoo-input.component';
import {ValidationHandlerService} from '../validation-handler.service';

@Component({
  selector: 'achoo-material-input',
  templateUrl: './achoo-material-input.component.html',
  styleUrls: ['./achoo-material-input.component.scss']
})
export class AchooMaterialInputComponent extends AchooInputComponent<any> {
  constructor(protected validationHandlerService: ValidationHandlerService) {
    super(validationHandlerService);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-material-input/achoo-material-input.component.ts